module.exports = __webpack_public_path__ + "img/hexagon.27a537d0.svg";